<template>
  <div>
    <header-top></header-top>
    <!-- 监管者 -->
    <div class="center">
      <!-- 未审核 0 -->
      <div v-if="this.status === 0" class="zero">
        <div class="zeroTop">
          <div class="portrait">
            <img src="../../assets/img/007.jpg" />
          </div>
          <div class="zeroName">{{userMobile}}</div>
          <div>(监管者：待审核)</div>
        </div>
        <div class="zeroCenter">您的申请还在审核中哦，请耐心等待~</div>
      </div>

      <!-- 审核失败 -1 -->
      <div v-if="this.status === -1" class="one">
        <div class="oneTop">
          <div class="portrait">
            <img src="../../assets/img/007.jpg" />
          </div>
          <div class="oneName">{{userMobile}}</div>
          <div>(监管者：审核失败)</div>
        </div>
        <div class="oneCenter">抱歉，您的审核未通过。</div>
        <div class="oneCause">原因为：{{remark}}</div>
        <div class="oneBtn">
          <button @click="openDialog">重新提交</button>
        </div>
      </div>

      <!-- 审核通过 -->
      <div v-if="this.status === 1" class="two">
        <div class="twoTop">
          <div class="portrait">
            <img src="../../assets/img/007.jpg" />
          </div>
          <div class="twoName">{{userMobile}}</div>
          <div>(监管者：审核通过)</div>
          <!-- <div class="iconfontBox" @click="getNews">
            <i class="iconfont icon-lingdang"></i>
            <div class="num">3</div>
          </div>-->
        </div>

        <div class="middle">
          <div class="middleTop">
            <div class="urgentList" :class="{ active: this.$route.meta.govTab === 'list' }">
              <router-link to="/user/gov/urgentList">销售点列表</router-link>
            </div>
            <div class="line"></div>
            <div class="urgentreview" :class="{ active: this.$route.meta.govTab === 'review' }">
              <router-link to="/user/gov/urgentreview">审核列表</router-link>
            </div>
          </div>
          <div class="router-content">
            <router-view/>
          </div>
        </div>
      </div>

      <!-- 对话框 -->
      <el-dialog :visible.sync="dialogVisible" class="dialog">
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="用户类型：" prop="role" required>
            <el-select v-model="form.role" placeholder="请选择" @change="changePeople">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- 上传图片 -->
          <el-form-item>
            <div v-if="form.role === 'company'">请上传营业执照，以及法人身份证或本人身份证正反面，格式为jpg或png，大小不能超过5M</div>
            <div v-if="form.role === 'gov'">请上传本人身份证正反面，格式为jpg或png，大小不能超过5M</div>
            <el-upload
              :action="domain"
              :before-upload="beforUp"
              :on-success="handleSuccess"
              :data="formData"
              :show-file-list="false"
              :multiple="true"
              accept="image/png, image/jpg, image/jpeg"
              v-if="form.role === 'company' || form.role === 'gov'"
              class="uploadBox"
            >
              <div v-for="(item,index) in form.options" :key="index" class="imgBox">
                <img :src="item" />
                <span class="iconfont icon-guanbi" @click.stop="deleteImg(index)"></span>
              </div>
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="reset">取 消</el-button>
          <el-button type="primary" @click="save">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <foot></foot>
  </div>
</template>

<script>
import headerTop from "@/components/header.vue";
import foot from "@/components/footer.vue";
import cityPicker from "@/components/CityPicker";
import { uploadImg, update, index } from "@/api/common.js";

export default {
  components: {
    headerTop,
    foot,
    cityPicker
  },
  data() {
    return {
      //该手机用户的id
      uid: "",
      //   省市区初始值
      defaultCity: {
        province: "福建省",
        city: "厦门市",
        area: ""
      },
      // 搜索选择的省市区
      province: "",
      city: "",
      area: "",
      //搜索选择的企业分类的id
      companyId: 0,
      companyList: [{ id: 0, title: "请选择企业分类" }],
      status: 0,
      userMobile: "",
      remark: "",
      dialogVisible: false,
      form: {
        role: "",
        options: []
      },
      //选择框的列表
      options: [
        {
          label: "市民",
          id: "others"
        },
        {
          label: "企业主",
          id: "company"
        },
        {
          label: "监管者",
          id: "gov"
        }
      ],
      companyName: "",
      domain: "",
      baseUrl: "",
      formData: {},
      urgentList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10
    };
  },
  created() {
    this.status = this.$store.getters.userinfo.status;
    this.userMobile = this.$store.getters.userinfo.mobile;
    this.remark = this.$store.getters.userinfo.remark;
    this.uid = this.$store.getters.userinfo.id;
    if (this.$store.getters.userinfo.role === "company") {
      this.$router.push({
        path: "/user/company"
      });
    } else if (this.$store.getters.userinfo.role === "others") {
      this.$router.push({
        path: "/maps"
      });
    }
    this.getCompanyList();
    this.getStationList();
  },
  methods: {
    // 获得企业分类
    getCompanyList() {
      const offset = (this.currentPage - 1) * this.pageSize;
      index("urgentCompany", {
        offset,
        limit: this.pageSize
      }).then(res => {
        this.companyList.push(...res.data.rows);
        if (this.companyList.length - 1 < res.data.count) {
          this.currentPage++;
          this.getCompanyList();
        }
      });
    },
    // 获取应急点列表
    getStationList(num) {
      if (num === 1) {
        this.currentPage = 1;
      }
      const offset = (this.currentPage - 1) * this.pageSize;
      let payload = {
        offset,
        limit: this.pageSize,
        title: this.companyName,
        companyId: this.companyId
      };
      index("urgentreview", payload).then(res => {
        this.urgentList = res.data.rows;
        this.total = res.data.count;
      });
    },
    openDialog() {
      this.dialogVisible = true;
    },
    // 改变所选类型
    changePeople() {
      if (this.form.role === "1") {
        this.form.options = [];
      }
    },
    beforUp() {
      return uploadImg().then(res => {
        this.domain = res.data.uploadUrl;
        this.formData = {
          token: res.data.uploadToken
        };
        this.baseUrl = res.data.baseUrl;
      });
    },
    // 上传图片
    handleSuccess(response, file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        if (fileList[i].size / 1024 > 5000) {
          return;
        }
      }
      this.form.options.push(this.baseUrl + response.hash);
    },
    // 删除图片
    deleteImg(index) {
      this.form.options.splice(index, 1);
    },
    // 提交申请
    save() {
      if (!this.form.role) {
        return this.$message.error("请选择用户类型");
      } else if (
        this.form.role !== "others" &&
        !this.form.options.length
      ) {
        return this.$message.error("请上传相应图片");
      }
      update("webuserMaps", this.uid, { ...this.form }).then(async (res)=> {
        this.$message.success("重新提交申请成功");
        this.dialogVisible = false;
        await store.dispatch("user/getInfo");
        window.location.reload();
      });

    },
    // 取消
    reset() {
      this.form = {
        role: "",
        fileList: []
      };
      this.dialogVisible = false;
    },
    //查看新消息列表
    getNews() {
      this.$router.push({
        path: "/user/news"
      });
    },
    changeSelece(e) {
      this.province = e.data[0];
    },
    toAudit(id) {
      this.$router.push({
        path: `/user/gov/${id}`
      });
    },
    //分頁按鈕
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getStationList();
    }
  }
};
</script>

<style lang="scss" scoped>
.center {
  width: 800px;
  margin: 0 auto;
}
.zero,
.one {
  margin-top: 150px;
}
.two {
  margin-top: 30px;
}
.zeroTop,
.oneTop,
.twoTop {
  display: flex;
  justify-content: center;
  div:nth-child(3) {
    line-height: 100px;
    font-size: 20px;
    margin-left: 30px;
  }
}
.portrait {
  width: 98px;
  height: 98px;
  border-radius: 50%;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
.zeroName,
.oneName,
.twoName {
  line-height: 100px;
  margin-left: 30px;
  font-size: 20px;
}
.zeroCenter,
.oneCenter {
  margin-left: 180px;
  margin-top: 50px;
  font-size: 20px;
}
.zeroCenter {
  text-align: center;
}
.oneCause {
  margin-left: 180px;
  font-size: 20px;
  margin-top: 10px;
}
.oneBtn {
  margin-top: 40px;
  text-align: center;
  button {
    width: 100px;
    padding: 10px 0;
    border: none;
    background-color: #41a5ef;
    border-radius: 5px;
    color: #ffffff;
    outline: none;
    cursor: pointer;
  }
}
.imgBox {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 100px;
  height: 100px;
  margin: 0 3px 3px 0;
  img {
    width: 100%;
    height: 100%;
  }
  span {
    position: absolute;
    top: -10px;
    right: 0;
    color: #cccccc;
  }
}
.el-icon-plus {
  width: 100px;
  height: 100px;
  border: 1px solid #cccccc;
  text-align: center;
  line-height: 100px;
}
/deep/ .uploadBox {
  .el-upload {
    text-align: left;
  }
  i {
    text-align: center;
  }
}
.iconfontBox {
  position: relative;
  line-height: 100px;
  margin-left: 10px;
  cursor: pointer;
  .iconfont {
    font-size: 24px;
  }
}
.num {
  position: absolute;
  top: 33px;
  right: -1px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background-color: #ff0000;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #ffffff;
}
.middle {
  margin-top: 50px;
  .middleone {
    font-size: 20px;
  }
  .please {
    div {
      line-height: 35px;
    }
    display: flex;
    justify-content: flex-start;
    margin: 30px 0;
  }
}
.chooseCompanyId {
  margin-bottom: 30px;
  span:nth-child(1) {
    line-height: 38px;
    font-size: 16px;
  }
  .el-select {
    width: 450px;
  }
}
.choosename {
  .el-input {
    width: 400px;
    margin-right: 70px;
  }
}
.stationList {
  margin-top: 20px;
}
.stationName {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  div {
    font-size: 18px;
    margin-bottom: 5px;
  }
}
.station {
  margin-bottom: 10px;
}
.el-pagination {
  margin-top: 100px;
}

.middleTop {
  display: flex;
  justify-content: space-around;
  font-size: 25px;
  margin-bottom: 80px;
  .line {
    border-left: 1px solid #2e2c2d;
    height: 50px;
  }
  .urgentList {
    padding: 8px 0 0 5px;
    width: 170px;
    text-align-last: justify;
    &.active {
      a {
        color: #41a5ef;
      }
      border-bottom: 2px solid #41a5ef;
    }
  }
  .urgentreview {
    padding: 8px 5px 0 0;
    width: 200px;
    text-align-last: justify;
    &.active {
      a {
        color: #41a5ef;
      }
      border-bottom: 2px solid #41a5ef;
    }
  }
}
a {
  text-decoration: none;
  color: #2e2c2d;
}

@media screen and (min-width: 320px) and (max-width: 980px) {
  .center {
    width: 100%;
  }
  .zeroTop,
  .twoTop,
  .oneTop,
  .threeTop {
    display: block;
    text-align: center;
  }
  .zeroName,
  .twoName,
  .oneName,
  .threeName {
    line-height: initial;
    margin: 5px 0 0;
  }
  .zeroCenter,
  .oneCenter,
  .oneCause,
  .oneInfo {
    margin: 10px;
  }
  .zeroTop div:nth-child(3),
  .twoTop div:nth-child(3),
  .oneTop div:nth-child(3),
  .threeTop div:nth-child(3) {
    line-height: initial;
    margin: 5px 0 0;
  }
  .portrait {
    width: 100%;
    height: auto;
    img {
      width: 50px;
      height: 50px;
    }
  }
  .middle {
    margin: 0;
  }
  .el-pagination {
    margin-top: 20px;
  }
  .middleTop {
    display: flex;
    font-size: 20px;
    padding: 10px 0;
    margin-bottom: 0;
    .line {
      height: 25px;
    }
    .urgentList {
      padding: 0;
      width: auto;
    }
    .urgentreview {
      padding: 0;
      width: auto;
    }
  }
}
</style>
<style>
.middle .chooseCompanyId .el-select {
  width: 100%;
}
.middle .choosename {
  display: flex;
}
.middle .choosename .el-input {
  width: 100%;
  margin-right: 10px;
}
</style>

<style>
.dialog .el-dialog {
  width: 35%;
}
@media screen and (min-width: 320px) and (max-width: 980px) {
  .dialog .el-dialog {
    width: 90%;
  }
  .router-content {
    padding: 0;
  }
  .el-message-box {
    width: 90%;
    top: 40%;
    position: absolute;
    left: 5%;
  }
}
</style>
